

































import { Component, Vue, Prop, Emit, Watch } from "vue-property-decorator";
import { WebhookDto } from "@/store/webhooks/webhook.interface";
import dayjs from "dayjs";
import Webhook from "@/store/webhooks";

@Component
export default class AppWebhookItem extends Vue {
  @Prop() item: WebhookDto;
  @Prop() index: number;
  updatedItem: WebhookDto;

  get formatTotal() {
    let val = (this.item.total / 1).toFixed(0).replace(",", ".");
    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  get percentage() {
    return parseInt(
      ((this.item.total_sented * 100) / this.item.total).toFixed(0)
    );
  }

  @Watch("item")
  onItemChanged(val: WebhookDto, oldVal: WebhookDto) {
    this.item = val;
  }

  get startDate() {
    return dayjs(this.item.send_date).format("DD/MM/YYYY");
  }

  get startTime() {
    return dayjs(dayjs().format("YYYY-MM-DD ") + this.item.start_time).format(
      "HH:mm"
    );
  }

  async onResume() {
    await Webhook.updateOne(
      this.item.id as number,
      {
        status_id: 3
      } as any
    );
  }

  async onPause() {
    await Webhook.updateOne(
      this.item.id as number,
      {
        status_id: 6
      } as any
    );
  }

  @Emit("itemUpdated")
  async itemUpdated() {
    return {
      item: this.updatedItem,
      index: this.index
    };
  }

  mounted() {
    this.sockets.subscribe("webhookUpdated_" + this.item.id, (data: any) => {
      this.updatedItem = data;
      this.itemUpdated();
    });
  }

  destroyed() {
    this.sockets.unsubscribe("webhookUpdated_" + this.item.id);
  }
}
